
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.912 7.298a5.612 5.612 0 00-5.614-5.614 5.612 5.612 0 00-5.614 5.614 5.612 5.612 0 005.614 5.614 5.612 5.612 0 005.614-5.614zm4.93 9.751l-.793.793a.421.421 0 01-.596 0l-4.26-4.26a.416.416 0 01-.123-.298v-.463A7.297 7.297 0 010 7.298 7.297 7.297 0 017.298 0a7.297 7.297 0 015.523 12.07h.463c.112 0 .218.046.298.123l4.26 4.26a.421.421 0 010 .596zM10.947 6.877v.842c0 .232-.19.421-.42.421H8.14v2.386c0 .232-.19.421-.42.421h-.843a.422.422 0 01-.42-.42V8.14H4.07a.422.422 0 01-.42-.42v-.843c0-.231.189-.42.42-.42h2.386V4.07c0-.231.19-.42.421-.42h.842c.232 0 .421.189.421.42v2.386h2.386c.232 0 .421.19.421.421z"}})])
          )
        }
      }
    